import api from './api-v1';

// Create new classeur
export const createClasseur = async (data) => {
  try {
    const response = await api.post('/classeurs', data);
    return response.data;	
  } catch (error) {
    console.error('Error creating classeur:', error);
    throw error;
  }
};

// Update classeur by id
export const updateClasseur = async (id, data) => {
  try {
    const response = await api.put(`/classeurs/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating classeur:', error);
    throw error;
  }
};

// Get all classeurs
export const getClasseurs = async () => {
  try {
    const response = await api.get('/classeurs');
    return response.data;
  } catch (error) {
    console.error('Error fetching classeurs:', error);
    throw error;
  }
};

// Get classeur by id
export const getClasseurID = async (id) => {
  try {
    const response = await api.get(`/classeurs/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching classeur:', error);
    throw error;
  }
};

// Delete classeur by id
export const deleteClasseur = async (id) => {
  try {
    const response = await api.delete(`/classeurs/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting classeur:', error);
    throw error;
  }
};